// Справочники сервисов: общий кэш списка, ссылки, подписи размера.
import { api } from '../api.ts'
import { useAsync } from './hooks.ts'
import { plural } from './format.ts'
import type { DocSection, DocUnit } from '../types.ts'

let unitsPromise: Promise<DocUnit[]> | null = null

/** Список справочников один на всё приложение: меняется редко (синхронизация раз в сутки). */
export function loadDocUnits(force = false): Promise<DocUnit[]> {
  if (!unitsPromise || force) {
    unitsPromise = api.get<DocUnit[]>('/api/docs').catch((e: unknown) => {
      unitsPromise = null
      throw e
    })
  }
  return unitsPromise
}

export function useDocUnits() {
  return useAsync(() => loadDocUnits(), [])
}

export function docHref(unit: string, sectionNo?: number, part?: string): string {
  return `/knowledge/docs/${encodeURIComponent(unit)}${part ? `?p=${encodeURIComponent(part)}` : ''}${sectionNo !== undefined ? `#s${sectionNo}` : ''}`
}

export interface DocPart {
  part: string
  title: string
  sections: DocSection[]
}

/** Разделы справочника по частям в порядке следования; у единого файла одна часть ''. */
export function groupParts(sections: DocSection[]): DocPart[] {
  const out: DocPart[] = []
  for (const s of sections) {
    let p = out.find((x) => x.part === s.part)
    if (!p) out.push((p = { part: s.part, title: s.part ? s.part_title || s.part : 'Обзор', sections: [] }))
    p.sections.push(s)
  }
  return out
}

/** «125 тыс. знаков» — размер справочника. */
export function formatChars(n: number): string {
  if (n < 1000) return `${n} ${plural(n, ['знак', 'знака', 'знаков'])}`
  return `${Math.round(n / 1000)} тыс. знаков`
}

/** Справочники, относящиеся к сервисам (id справочника совпадает с сервисом или сервис указан в service_ids). */
export function unitsForServices(units: DocUnit[], serviceIds: string[]): DocUnit[] {
  const set = new Set(serviceIds)
  return units.filter((u) => u.kind === 'service' && (set.has(u.unit) || u.service_ids.some((s) => set.has(s))))
}

/** Номер раздела из «#s5». */
export function sectionFromHash(hash: string): number | null {
  const m = /^#s(\d+)$/.exec(hash)
  return m ? Number(m[1]) : null
}
